import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import React from 'react'
import { customStyles } from '../../../styles'

export const LightText = ({ text, sx, variant }) => {
   const CustomLightText = styled(Typography)(() => (({
    color: customStyles.colors.lightColor,
    textAlign: 'center',
    ...sx
   })))
  return (
    <CustomLightText m={2} component="p" variant={ variant }>{ text }</CustomLightText>
  )
}
